// icons
import { motion } from 'framer-motion';
import { FaAngleDown } from 'react-icons/fa6';
import { GoArrowUpRight } from 'react-icons/go';
//
import { useState } from 'react';
// style
import style from './MobMenu.module.css';
// data
import { contactData } from '../../../data/ContactData';
import { NavLink, Link } from 'react-router-dom';

const MobileMenu = ({ menu }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [clicked, setClicked] = useState(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    !isOpen
      ? (document.body.style.overflow = 'hidden')
      : (document.body.style.overflow = 'visible');
  };

  const toggleSubMenu = {
    enter: {
      height: 'auto',
      overflow: 'hidden',
    },
    exit: {
      height: 0,
      overflow: 'hidden',
    },
  };
  return (
    <div className={style.menu}>
      <div className={style.burger} onClick={toggleMenu}>
        <div
          className={isOpen ? `${style.bar} && ${style.open}` : style.bar}
        ></div>
        <div
          className={isOpen ? `${style.bar} && ${style.open}` : style.bar}
        ></div>
        <div
          className={isOpen ? `${style.bar} && ${style.open}` : style.bar}
        ></div>
      </div>
      <motion.div
        className={style.links}
        inherit={{ x: '-100%' }}
        animate={{ x: isOpen ? '0%' : '-100%' }}
      >
        <ul className={style.top}>
          {menu.map(({ title, subMenu, url }, i) => {
            const hasSubMenu = subMenu?.length > 0;
            const isClicked = clicked === i;

            return (
              <li
                key={title}
                className={style.link}
                onClick={() => setClicked(isClicked ? null : i)}
              >
                {hasSubMenu ? (
                  <span className={style.sub_link}>
                    {title}{' '}
                    {hasSubMenu && (
                      <FaAngleDown
                        className={isClicked && style.sub_link_rol}
                      />
                    )}
                  </span>
                ) : (
                  <Link
                    className={style.sub_link}
                    to={url}
                    onClick={toggleMenu}
                  >
                    {title}
                  </Link>
                )}
                {hasSubMenu && (
                  <motion.ul
                    className={style.subMenuLinks}
                    initial="exit"
                    animate={isClicked ? 'enter' : 'exit'}
                    variants={toggleSubMenu}
                  >
                    {subMenu?.map((item) => (
                      <li className="" key={item.id} onClick={toggleMenu}>
                        <NavLink to={item.url} className={style.subMenuLink}>
                          {item.title} <GoArrowUpRight />
                        </NavLink>
                      </li>
                    ))}
                  </motion.ul>
                )}
              </li>
            );
          })}
        </ul>
        <div className={style.bottom}>
          <ul className={style.contacs}>
            {contactData.map((item) => (
              <li key={item.id} className={style.contac}>
                {item.icon} <span>{item.name}</span>
              </li>
            ))}
          </ul>
          <span className={style.sparta}>
            © 2025 - Sparta Казань, Татарстан
          </span>
        </div>
      </motion.div>
    </div>
  );
};
export default MobileMenu;
